<template>
    <!-- 2022\05\29每次只能选一个文件，那就没必要列一个文件列表了，文件列表的方案先预留 -->
    <!-- 上传组件的样式就先定为一个按钮，无需弹窗 -->
    <div>
        <div class="main">
            <div class="info">
                <!-- <div class="info-item">
          <span>存储空间：</span>
          2.0G/50G
        </div> -->
                <div class="info-item">
                    <span>当前路径：</span>
                    <el-link style="font-size: 16px" type="primary" v-for="(item, index) in openFolderList" :key="index"
                        @click="getFolderInfo(index)">{{ item.folder_name }}/</el-link>
                    <!-- v-show="selectFileList.length || selectFolderList.length" -->
                    <div class="info-item-more">
                        <el-button-group class="info-item-more"
                            v-show="selectFileList.length || selectFolderList.length">
                            <el-button @click="showMoveTree" size="mini" type="success" :disabled="selectFolderList.length > 0">移动</el-button>
                            <el-button @click="delList" size="mini" type="danger">删除</el-button>
                        </el-button-group>
                        <el-dropdown @command="invoking">
                            <el-button size="mini" type="primary">
                                添加<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="createFolder">新建目录</el-dropdown-item>
                                <!-- command="showUploadFile" -->
                                <el-dropdown-item>
                                    <upload-file :autoClose="true" :suffix="[]" :openFolderList="openFolderList"
                                        @onSuccess="uploadSuccess" @onError="uploadErr">
                                    </upload-file>

                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>

            <div v-if="loadingFile || loadingFolder" style="position: absolute;
    height: 100%;
    text-align: center;
    width: 100%;" v-loading="loadingFile || loadingFolder"></div>
            <div v-else-if="folderList.length == 0 && fileList.length == 0" style="position: absolute;
    height: 100%;
    text-align: center;
    width: 100%;">
                <notFundDataVue />
            </div>
            <template v-else>
                <div class="folder" v-if="folderList.length > 0">
                    <div class="folder-tit">文件夹</div>
                    <div class="floder-list">
                        <div class="folder-item" v-for="(item, index) in folderList" :key="index"
                            @click.self="openFolder(item)" style="    display: flex;
    justify-content: flex-start;
    justify-items: center;">
                            <i class="el-icon-folder" style="font-size:30px;line: height 30px;font-weight: bold;"></i>
                            &nbsp;&nbsp;&nbsp;
                            <span style="line-height: 30px;">{{ item.folder_name }}</span>
                            <el-checkbox :class="{
                                'folder-checked': selectFolderList.includes(item.folder_id),
                            }" class="folder-checkbox" @change="selectList(item, 'selectFolderList')"
                                :checked="selectFolderList.includes(item.folder_id)"></el-checkbox>
                        </div>
                    </div>
                </div>
                <div class="folder" ref="folder" v-if="fileList.length > 0">
                    <div class="folder-tit">文件资源</div>
                    <div class="file-list">
                        <div class="folder-file" v-for="(item, index) in fileList" :key="index"
                            style="background-color:white;">
                            <div v-if="item.auth_status == 1" style="font-size: 12px;line-height: 1.4;color: red;position: absolute;top: 0;background: grey;color: white;z-index: 999;">
                                审核中
                            </div>
                            <div v-else-if="item.auth_status == 3" style="font-size: 12px;line-height: 1.4;color: red;position: absolute;top: 0;background: goldenrod;color: white;z-index: 999;">
                                疑似{{item.unauth_reason}}
                            </div>
                            <div v-else-if="item.auth_status == 4" style="font-size: 12px;line-height: 1.4;color: red;position: absolute;top: 0;background: red;color: white;z-index: 999;">
                                违规:{{item.unauth_reason}}
                            </div>

                            <el-image v-if="item.file_type == 1" fit="contain"
                                @click="contentClick ? contentClick(item.file_url, item.file_type) : previewFileDialog(index)"
                                class="folder-file-icon" :src="item.file_url" />

                            <el-image v-else-if="item.file_type == 2" fit="contain"
                                @click="contentClick ? contentClick(item.file_url, item.file_type) : previewFileDialog(index)"
                                class="folder-file-icon" :src="defaultImg" />

                            <el-image v-else  fit="contain"
                                @click="contentClick ? contentClick(item.file_url, item.file_type) : previewFileDialog(index)"
                                class="folder-file-icon" :src="defaultAudioImg" />
                            <el-checkbox :class="{
                                'file-checked': selectFileList.includes(item.resource_file_id),
                            }" class="file-checkbox" @change="selectList(item, 'selectFileList')"
                                :checked="selectFileList.includes(item.resource_file_id)"></el-checkbox>

                            <div style="        padding: 5px 10px;height: 20%;
    bottom: 0;
    width: 100%;
    position: absolute;">

                                <div style="display: flex;justify-content: space-between;font-weight: 600;
    font-size: 14px;
    line-height: 160%;">
                                    <span style="max-width: 50%;    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;white-space: nowrap;">{{ item.file_url.substr(item.file_url.lastIndexOf("/") + 1) }}</span>
                                    <span v-if="item.file_size < (1024 * 1024)">{{ (Math.floor((item.file_size / 1024) *
                                            10) / 10)
                                    }}KB</span>
                                    <span v-else>{{ (Math.floor((item.file_size / 1024 / 1024) * 10) / 10) }}MB</span>
                                </div>
                                <div style="width: 100%;
    font-size: 12px;
    line-height: 1.4;
    color: #b8b8b8;text-align:left;">{{ item.create_time }}</div>

                            </div>
                        </div>
                    </div>
                    <div class="folder-pagination">
                        <pagination :background="true" @pageChange="pageChange" @sizeChange="sizeChange"
                            :total="totalNum" :pageCount="searchParams.page" :pageSize="searchParams.size"></pagination>
                    </div>
                </div>
            </template>
        </div>
        <!-- 在当前目录下创建目录， -->
        <el-dialog title="创建文件夹" :visible.sync="createFolder" width="40%">
            <el-input placeholder="请输入文件夹名称" v-model="folderName">
                <template slot="prepend">
                    于{{
                            (openFolderList.length &&
                                openFolderList[openFolderList.length - 1].folder_name) ||
                            "根"
                    }}目录下创建
                </template>
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="accomplish">完 成</el-button>
            </span>
        </el-dialog>
        <!-- 移动资源 -->
        <el-dialog title="移动目录与资源" :visible.sync="showMoveFolder" width="40%">
            <p>移动至</p>

            <el-tree node-key="folder_id" :expand-on-click-node="false" :data="folderTreeData" :props="defaultProps" @node-click="selectFolderTree">
            </el-tree>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmMove">确定</el-button>
            </span>
        </el-dialog>

        <!-- <upload-file
      :showUploadFile.sync="showUploadFile"
      :openFolderList="openFolderList"
      @onSuccess="uploadSuccess"
      @onError="uploadErr"
    >
    </upload-file> -->
        <preview-file :showPreview.sync="showPreview" :fileList="fileList" :idx.sync="previewFileIdx"></preview-file>
    </div>
</template>
<script>
import uploadFile from "./upload-file.vue";
import previewFile from "./preview-file.vue"
import pagination from "../pagination/pagination.vue";
import notFundDataVue from "../notFundData.vue";

export default {
    components: {
        uploadFile,
        previewFile,
        pagination,
        notFundDataVue
    },
    props: {
        filterData: {
            type: [Function],
            default: null
        },
        contentClick: {
            type: [Function],
            default: null
        }
    },
    data() {
        return {
            loadingFile: false,
            loadingFolder: false,
            defaultAudioImg: require('../../common/images/audio-default.svg'),
            defaultImg: require('../../common/images/video-default.svg'),
            openFolderList: [{ folder_name: "我的资源", folder_id: null }], // 打开文件夹的目录层级，应是对象形式
            createFolder: false, // 显示创建文件夹弹窗
            showMoveFolder: false, // 显示移动资源弹窗
            folderList: [], // 文件夹列表
            selectFolderList: [], // 选中的文件夹列表
            folderName: "", // 新创建的文件夹名称
            fileList: [], // 文件链表
            selectFileList: [], // 选中的文件列表
            totalNum: 0, // 资源总数，目前未使用
            searchParams: {
                // 现在暂无分页数据，以后可能会有
                page: 1,
                size: 30,
            },
            defaultProps: {
                children: "children",
                label: "folder_name",
            },
            folderTreeData: [], // 目录树形结构
            // 上传文件组件参数
            showUploadFile: false, // 是否显示上传弹窗
            showPreview: false, // 是否显示预览弹窗
            previewFileIdx: 0, // 要预览的文件的下标
        };
    },
    mounted() {
        this.getFolderInfo();
    },
    methods: {
        pageChange(e) {
            this.searchParams.page = e;
            let data = {
                folder_id: this.openFolderList.slice(-1)[0].folder_id || null
            }
            this.getFileList(data)
        },
        sizeChange(e) {
            this.searchParams.size = e;
            let data = {
                folder_id: this.openFolderList.slice(-1)[0].folder_id || null
            }
            this.getFileList(data)
        },
        invoking(e) {
            e && (this[e] = true);
        },
        showCreateFolder() {
            // 显示创建文件夹的弹窗
            this.createFolder = true;
            this.folderName = '';
        },
        accomplish() {
            // 创建文件夹
            if (!this.folderName) {
                this.$message.warning("请输入目录名称");
                return;
            }
            // 保存目录信息
            let data = { folder_name: this.folderName };
            let folder = this.openFolderList.length
                ? this.openFolderList.slice(-1)[0]
                : false;
            folder && (data.parent_folder_id = folder.folder_id);
            this.$API.addFolder(data).then(() => {
                this.createFolder = false;
                this.$message.success("创建文件夹成功");
                this.getFolderInfo();
            });
        },

        selectList(item, list) {
            if (this.filterData) { return }
            // 选中文件，目前选中状态不明显，后续改进
            let key = list === "selectFileList" ? "resource_file_id" : "folder_id";
            let index = this[list].indexOf(item[key]);
            if (index !== -1) {
                this[list].splice(index, 1);
            } else {
                this[list].push(item[key]);
            }
        },

        openFolder(item) {
            // 打开文件夹文件夹
            this.searchParams.page = 1
            this.openFolderList.push(item);
        },

        getFolderInfo(idx) {
            // 获取目录下的文件夹信息以及资源文件信息
            let fileData = {
                parent_folder_id: null,
            },
                folderData = {
                    parent_folder_id: null,
                };
            if (idx === this.openFolderList.length) {
                return;
            }
            if (idx !== undefined) {
                fileData = { folder_id: this.openFolderList[idx].folder_id };
                folderData = { parent_folder_id: this.openFolderList[idx].folder_id };
                this.openFolderList.splice(idx + 1, this.openFolderList.length);
            } else {
                if (this.openFolderList.length) {
                    let folder = this.openFolderList.slice(-1);
                    fileData = { folder_id: folder[0].folder_id };
                    folderData = { parent_folder_id: folder[0].folder_id };
                }
            }

            this.getFolderList(folderData);
            this.getFileList(fileData);
        },

        getFolderList(data) {
            // 获取文件夹信息
            this.loadingFolder = true;
            this.$API.getFolderList(data).then((res) => {
                this.loadingFolder = false;
                this.folderList.splice(0);
                this.folderList = res.data;
                this.selectFolderList.splice(0);
            }).catch(() => {
                this.loadingFolder = false;
            });
        },
        getFileList(data) {
            // 获取文件信息
            this.loadingFile = true;
            this.$API.getFileList({ ...data, ...this.searchParams }).then((res) => {
                this.loadingFile = false;
                this.fileList.splice(0);
                this.fileList = res.data.list;
                let { page, size, total } = { ...res.data.pagination }
                this.searchParams.page = page
                this.searchParams.size = size
                this.totalNum = total
                this.selectFileList.splice(0);
            }).catch(() => {
                this.loadingFile = false;
            });
        },

        async getUploaderToken() {
            // 获取上传文件token
            return await this.$API.getUploaderToken();
        },
        selectFolderTree(obj, node, sefl) {
            // 选中属性文件夹
            this.moveToFolder = obj;
        },
        async showMoveTree() {
            // 移动文件以及文件夹列表
            let res = await this.$API.getFolderListAll()
            let folders = res.data;

            function loop(folder) {

                let children_folders = [];
                folders.forEach(folder2 => {
                    if (folder.folder_id === folder2.parent_folder_id) {
                        children_folders.push({
                            ...folder2
                        });
                    }
                });

                if (children_folders.length > 0) {
                    children_folders.forEach(folder3 => {
                        folder3 = loop(folder3);
                    })
                }

                folder.children = children_folders
                return folder;
            }
            
            let ret_folders = [];
            folders.find(folder => {

                const findIndex = folders.findIndex(folder2 => folder2.folder_id === folder.parent_folder_id);
                if (findIndex >= 0) {//有父节点存在

                } else {
                    ret_folders.push(loop(folder))
                }
            });
            
            this.folderTreeData = [
                {
                    folder_id: null,
                    folder_name: "根目录",
                    children: ret_folders
                }
            ];
            this.showMoveFolder = true;
        },

        confirmMove() {
            this.$confirm(
                `确定将资源移动到${this.moveToFolder.folder_name}文件夹下吗？`
            ).then(async () => {
                await this.moveFile();

                this.showMoveFolder = false;
                this.selectFolderList.splice(0, this.selectFolderList.length);
                this.selectFileList.splice(0, this.selectFileList.length);

                this.getFolderInfo();
            });
        },

        async moveFile() {
            // 移动资源
            if (!this.selectFileList.length) {
                return;
            }
            let data = {
                ids: this.selectFileList,
                folder_id: this.moveToFolder.folder_id,
            };
            let res = await this.$API.moveFile(data)

            this.selectFileList.length = 0;
            if (!this.selectFolderList.length) {
                this.getFolderInfo();
            }
        },
        delList() {
            // 删除文件以及文件夹列表
            let hint = "";
            if (this.selectFileList.length && this.selectFolderList.length) {
                hint = "文件以及文件夹";
            } else if (this.selectFileList.length) {
                hint = "文件";
            } else if (this.selectFolderList.length) {
                hint = "文件夹";
            }
            
            this.$confirm(`删除后不可恢复，确认要删除么这些${hint}吗?`).then(async () => {
                await this.delFolder();
                await this.delFile();

                await this.getFolderInfo();
            });
        },
        async delFolder() {
            if (!this.selectFolderList.length) {
                return;
            }
            await this.$API.delFolder({ ids: this.selectFolderList });
        },
        async delFile() {
            if (!this.selectFileList.length) {
                return;
            }
            this.fileList.splice(0);
            await this.$API.delFile({ ids: this.selectFileList })
        },

        uploadSuccess(result) {
            if (result === undefined) {
                return;
            }
            
            console.log(result);
            // 文件上传成功
            // 判断是否处于根目录，是根目录调用接口查询文件
            if (result.code === 1000) {
                this.$message.success("上传成功");
                let folder = this.openFolderList.slice(-1);
                this.openFolderList.length && this.getFileList({ folder_id: folder[0].folder_id });
            } else {
                this.$message.warning(result.message);
            }
        },
        uploadErr(err) {
            // 文件上传失败
            this.$message.error(err.message);
        },
        previewFileDialog(idx) {
            if (this.filterData) { return }
            this.previewFileIdx = idx;
            this.showPreview = true
        }
    },
    watch: {
        openFolderList: {
            deep: true,
            handler() {
                this.getFolderInfo();
            },
        },
        showPreview(newVal, oldVal) {
            if (!newVal) {
                this.previewFile = {}
            }
        }
    },
};
</script>
<style scoped lang="scss">
.info {
    //   margin: 0 0 30px;
    background: #fff;
    padding: 10px 20px;

    .info-item {
        display: flex;
        align-items: center;
        margin: 10px 0;

        span {
            color: #999;
        }

        .info-item-more {
            margin-left: auto;
            margin-right: 20px;
        }
    }
}

.folder {
    display: flex;
    flex-wrap: wrap;

    .folder-tit {
        color: #999;
        padding: 10px;
        width: 100%;
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .floder-list {
        display: grid;

        //grid-template-rows: repeat(5, 50px);

        grid-template-columns: repeat(6, calc(16.6666% - 17px));
        grid-row-gap: 20px;
        grid-column-gap: 20px;
        width: 100%;

        .folder-item:hover {
            .folder-checkbox {
                visibility: inherit;
            }
        }

        .folder-item {
            cursor: pointer;
            user-select: none;
            border-radius: 4px;
            padding: 20px;
            background: #fff;
            border: 1px solid #fff;
            box-shadow: 0 2px 4px 0 #ccc;
            transition: all 0.2s;
            position: relative;

            .folder-checked {
                visibility: visible !important;
            }

            .folder-checkbox {
                position: absolute;
                right: 8px;
                top: 8px;
                visibility: hidden;
            }
        }

        .folder-item:hover {
            // background:rgba(37,165,137,.6);
            // color:#FFF;
            transform: scale(1.1);
        }
    }

    .file-list {
        display: grid;

        //grid-template-rows: repeat(5, 50px);

        grid-template-columns: repeat(6, calc(16.6666% - 17px));
        grid-row-gap: 20px;
        grid-column-gap: 20px;
        width: 100%;

        .folder-file {
            cursor: pointer;
            position: relative;
            border: 1px solid #fff;
            text-align: center;
            padding-top: calc(100%);
            border-radius: 5px;
            overflow: hidden;
            transition: all 0.3s;
            width: calc(100%);
            height: 0;
            //aspect-ratio: 1 / 1;

            .folder-file-icon {
                width: 80%;
                height: 80%;
                display: block;
                position: absolute;
                top: 0%;
                left: 10%;
                object-fit: cover;
            }

            .folder-file-name {
                margin-top: 10px;
            }

            .file-checked {
                visibility: visible !important;
            }

            .file-checkbox {
                position: absolute;
                right: 8px;
                top: 8px;
                visibility: hidden;
            }
        }

        .folder-file:hover {
            transform: scale(1.05);
            box-shadow: 2px 2px 8px 0 #666;

            .file-checkbox {
                visibility: inherit;
            }
        }
    }

    .folder-pagination {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        justify-content: flex-end;
        width: 100%;
    }
}
</style>